export const objectPropertyComparator = (propName, reverse) => (a, b) => {
    if (a[propName] < b[propName]) return reverse ? 1 : -1;
    if (a[propName] > b[propName]) return reverse ? -1 : 1;
    return 0;
};
